import { Component } from "react";
import { connect } from "react-redux";

import ColumnSelectionButton from "../../core/ColumnSelectionButton.js";
import DataTableContainer from "../../core/grid/DataTableContainer.js";
import { Dialog } from "../../core/overlays/Dialogs.js";
import { createSelectionModel } from "@/app-utils/selection-model.ts";
import { type InputTableQuerySpec, type SampleType } from "@/graphql.ts";
import {
  type ITableData,
  type ITableDataState,
  createUniqueKeyFromTableSpec,
  getTableDataSlice,
  getTableQuerySpecWithSelection,
} from "@/redux/modules/table-data.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { DATATABLE_ID_TYPE, ENTITY_TYPE, SAMPLE_TABLE_COLUMNS } from "@/settings/settings.ts";

interface ISelectSamplesDialogState {}

export interface ISelectSamplesDialogOwnProps {
  sampleType: SampleType;
  close: () => void;
  initialSelection: number[];
  setSampleEditingSpec: (tableQuerySpecWithSelection: InputTableQuerySpec) => void;
}

interface ISelectSamplesDialogDispatchProps {}

interface ISelectSamplesDialogAppStateProps {
  tableData: ITableDataState;
}

export interface ISelectSamplesDialogProps
  extends ISelectSamplesDialogAppStateProps,
    ISelectSamplesDialogDispatchProps,
    ISelectSamplesDialogOwnProps {}

function mapStateToProps(state: IAppState, _ownProps: ISelectSamplesDialogOwnProps): ISelectSamplesDialogAppStateProps {
  return {
    tableData: state.tableData,
  };
}

function mapDispatchToProps(_dispatch): ISelectSamplesDialogDispatchProps {
  return {};
}

class SelectSamplesDialogImpl extends Component<ISelectSamplesDialogProps, ISelectSamplesDialogState> {
  constructor(props: ISelectSamplesDialogProps) {
    super(props);
  }

  private SAMPLE_TABLE_SPEC: InputTableQuerySpec = {
    id: this.props.sampleType.id,
    idType: DATATABLE_ID_TYPE.ENTITY,
    queryType: ENTITY_TYPE.SAMPLE_TYPE,
    resultType: ENTITY_TYPE.SAMPLE,
  };

  onSave = (): void => {
    const tableData: ITableData = getTableDataSlice(this.props.tableData, this.SAMPLE_TABLE_SPEC);
    const selectionTableSpec: InputTableQuerySpec = getTableQuerySpecWithSelection(tableData);
    this.props.setSampleEditingSpec(selectionTableSpec);
    this.props.close();
  };

  render() {
    const sampleTableInitOptions = {
      sortExpression: `-${SAMPLE_TABLE_COLUMNS.CREATED}`,
      initialSelectionModel: createSelectionModel(this.props.initialSelection),
    };
    const tableData: ITableData = getTableDataSlice(this.props.tableData, this.SAMPLE_TABLE_SPEC);
    const enabledSelectButton = tableData?.selectionModel?.selectedIds?.length;

    return (
      <Dialog
        headerProps={{
          title: "Samples",
          subtitle: "Select the samples to analyze",
          actionWidgets: [
            <ColumnSelectionButton
              portalContext={createUniqueKeyFromTableSpec(this.SAMPLE_TABLE_SPEC)}
              key={"sample-selection-table"}
            />,
          ],
        }}
        closeFn={this.props.close}
        fullScreen={true}
        noCardPadding={true}
        mainActionButtonProps={{
          children: "Done",
          onPress: this.onSave,
          isDisabled: !enabledSelectButton,
        }}
      >
        <div style={{ height: "100%" }}>
          <DataTableContainer
            key={createUniqueKeyFromTableSpec(this.SAMPLE_TABLE_SPEC)}
            tableSpec={this.SAMPLE_TABLE_SPEC}
            hideCheckboxes={false}
            tableInitializationOptions={sampleTableInitOptions}
          />
        </div>
      </Dialog>
    );
  }
}

const SelectSamplesDialog = connect<
  ISelectSamplesDialogAppStateProps,
  ISelectSamplesDialogDispatchProps,
  ISelectSamplesDialogOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(SelectSamplesDialogImpl);

export { SelectSamplesDialogImpl };
export default SelectSamplesDialog;
